module.exports = __webpack_public_path__ + "static/media/13.4457dc40.png";